import LocomotiveScroll from 'locomotive-scroll';
const header = document.getElementById('header');
let hidden = false, estatico = true;


const scroll = new LocomotiveScroll({
  el: document.querySelector('[data-scroll-container]'),
  smooth: true,
  getSpeed: true,
  getDirection: true,
});

scroll.on('scroll',(instance)=>{
	let headerHeight = header.getBoundingClientRect().height;
if(instance.direction === 'down' && estatico){
  if(instance.scroll.y > headerHeight){
	header.classList.add('pinned');
	estatico = false;
  }
}
if(instance.direction === 'up' && !estatico){
  if(instance.scroll.y <= headerHeight){
	header.classList.remove('pinned');
	if(header.classList.contains('home')){
			header.classList.remove('navbar-dark','bg-dark');
			header.classList.add('navbar-light','bg-light');
		}
		estatico = true;
  }
}

if(instance.direction === 'down' && !hidden){
  if(instance.scroll.y>(headerHeight+200)){
	header.classList.remove('pinned');
	header.classList.add('unpinned');
  hidden = true;
  }
}

if(instance.direction === 'up' && hidden){
  //console.log('show');
  header.classList.remove('unpinned');
  header.classList.add('pinned');
  hidden = false;
}

});

export default {
  init() {
    let closed=true;
    $('.hamburger-menu, .menu-text').click(function(e){
      if(closed){
        scroll.stop();
        closed=false;
        $('body').css('overflow-y', 'hidden');
      } else {
        scroll.start();
        closed=true;
        $('body').css('overflow-y', 'auto');
      }
      let text = ($('.menu-text').text() === 'Cerrar') ? 'Menú' : 'Cerrar';
      let time;
      if(text==='Cerrar') {
        time = 100;
      } else {
        time = 700;
      }
      $('.full-menu').toggleClass('visible');
      $('.upper-bar').toggleClass('menu-is-open');

      setTimeout(function(){
        $('.upper-bar').toggleClass('active');
        $('.menu-text').text(text);
      }, time);

      e.stopPropagation(); // This is the preferred method.
      return false;        // This should not be used unless you do not want
    })

    $('.client-wrap').mouseover(function(){
      $('.client-wrap').removeClass('light-client');
      $('.client-wrap').not(this).addClass('light-client');
    });

    $('.client-wrap').mouseout(function(){
      $('.client-wrap').removeClass('light-client');
    });

    $(document).on(
      'keydown', function(event) {
        if (event.key == 'Escape') {
          $('.full-menu').removeClass('visible');
          $('.open-menu-overlay').removeClass('active');
        }
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $(window).on('load', function(){
      scroll.update();
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js